import { ImpressionEvent } from './schemas'

type ImpressionEventProps = {
  category: string
  action: string
  label: string
}

export const createGenericImpressionEvent = ({
  category,
  action,
  label,
}: ImpressionEventProps): ImpressionEvent => ({
  event: 'impression',
  event_data: {
    category: category.toLowerCase(),
    action: action.toLowerCase(),
    label: label.toLowerCase(),
  },
})
